import Fallback from './Schemas';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./Schemas.page'),
});
